import gtmAddEvent from './gtmAddEvent';

export default (pathname: string) => {
    // Gtm tracking
    gtmAddEvent('content-view', { 'content-name': pathname });
};
